export default __webpack_public_path__ + "static/media/banking.961e27f6.svg";